import types from '../types.js';
import { clearStoredPortalPreview, storePortalPreview } from '../../utils/portalPreview';

export const loadPortals = () => {
  return { type: types.LOAD_PORTALS, payload: null };
};

export const selectPortal = payload => {
  return { type: types.SELECT_PORTAL, payload };
};

export const startPortalPreview = portal => {
  storePortalPreview(portal);
  return { type: types.START_PORTAL_PREVIEW, payload: portal };
};

export const stopPortalPreview = () => {
  clearStoredPortalPreview();
  return { type: types.STOP_PORTAL_PREVIEW };
};

export const getSelectedPortal = state => {
  return state.portalReducer.selectedPortal;
};

export const getIsPortalPreview = state => {
  return Boolean(state.portalReducer.previewPortalId);
};

export const getPreviewPortalId = state => {
  return state.portalReducer.previewPortalId;
};

export const getPortals = state => {
  return state.portalReducer.portals;
};
